import React from 'react'

import Text from '../../atoms/Text/Text'
import { ProgressStatus } from 'app/app/(client)/utils/client-constants'

export interface ProgressBarProps {
  value: number // 0-100
  label?: string
  className?: string
  variant?: ProgressStatus.LOADING | ProgressStatus.FAILURE | ProgressStatus.SUCCESS
  size?: 'small' | 'medium' | 'large'
  progressValueVisible?: boolean
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  label = '',
  className = '',
  variant = ProgressStatus.LOADING,
  size = 'medium',
  progressValueVisible = true
}) => (
  <div className={`progress-bar ${className}`}>
    <div className={`flex ${progressValueVisible ? 'justify-between' : 'justify-center animate-opacity-fade'} mb-2`}>
      <Text
        id={`progress-label-${value}`}
        as="span"
        className={`progress-bar__label break-all progress-bar__label--${size}`}
      >
        {label}
      </Text>
      {progressValueVisible && (
        <Text id={`progress-value-${value}`} as="span" className={`progress-bar__value progress-bar__value--${size}`}>
          {value}%
        </Text>
      )}
    </div>
    <div className="progress-bar__wrapper">
      <div
        className={`progress-bar__bar progress-bar__bar--${variant} ${!progressValueVisible ? 'progress-bar__bar--indeterminate' : ''}`}
        style={
          progressValueVisible
            ? {
                transform: `translateX(${value - 100}%)`
              }
            : undefined
        }
      ></div>
    </div>
  </div>
)

export default ProgressBar
